/** Types of nodes allowed within modules of an export. */
export enum ExportNodeType {
  banner = 'BANNER',
  begin = 'MODULE_START_POINT',
  custom = 'CUSTOM',
  data = 'DATA_ACCESS',
  dataAccessCompletion = 'DATA_ACCESS_COMPLETION',
  dtmf = 'DTMF_MENU',
  exit = 'MODULE_END_POINT',
  flushPrompts = 'FLUSH_PROMPTS',
  humanAssistedResolution = 'HUMAN_ASSISTED_RESOLUTION',
  input = 'INPUT',
  loopEscalation = 'LOOP_ESCALATION',
  module = 'MODULE',
  moduleReference = 'VARIABLE_MODULE_REFERENCE',
  /**
   * OASYS node.
   *
   * @note Still exports `'AMELIA'` because the product was renamed from Amelia to OASYS
   * and PE still expects the original export type string.
   */
  oasys = 'AMELIA',
  playSavedPrompt = 'PLAY_SAVE_PROMPT',
  prompt = 'PROMPT',
  promptReference = 'PROMPT_REFERENCE',
  report = 'REPORTING',
  richText = 'RICH_TEXT',
  savePrompt = 'SAVE_PROMPT',
  session = 'START_SIMULTANEOUS_SESSION',
  sessionCompletion = 'SIMULTANEOUS_SESSION_COMPLETION',
  tab = 'TABULAR',
  taskOrchestration = 'TASK_ORCHESTRATION',
  trustedResponse = 'TRUSTED_RESPONSE',
  vxmlRender = 'VXML_RENDER',
  withFiller = 'WITH_FILLER'
}
